export default __webpack_public_path__ + "static/media/R6.38d63099.png";